// 统一使用环境变量配置API地址
export const base = process.env.VUE_APP_BASE_API;
export const uploadUrl = base + "/upload/file";
export const uploadPicUrl = base + "/upload/oss_file";
